import { Injectable, Inject } from "@angular/core";
import { DOCUMENT } from "@angular/common";

@Injectable({ providedIn: "root" })
export class HreflangService {
  private languages = ["EN", "TR", "FR", "RU", "AR"];

  constructor(@Inject(DOCUMENT) private document: Document) {}

  updateHreflangTags(
    activeLang: string,
    route: string,
    baseUrl = "https://zirvecompany.net"
  ) {
    route = route.replace(/^\/+/, "");
    baseUrl = baseUrl.replace(/\/+$/, "");

    // إزالة الوسوم القديمة
    this.removeLinks('link[rel="canonical"]');
    this.removeLinks('link[rel="alternate"][hreflang]');

    // Canonical
    this.addLink("canonical", `${baseUrl}/${activeLang}/${route}`);

    // hreflang لكل اللغات
    this.languages.forEach((lang) => {
      this.addAlt(`${baseUrl}/${lang}/${route}`, lang);
    });

    // x-default (افتراضي مثلاً للإنجليزية)
    this.addAlt(`${baseUrl}/EN/${route}`, "x-default");
  }

  private addLink(rel: string, href: string) {
    const link = this.document.createElement("link");
    link.setAttribute("rel", rel);
    link.setAttribute("href", href);
    this.document.head.appendChild(link);
  }

  private addAlt(href: string, hreflang: string) {
    const link = this.document.createElement("link");
    link.setAttribute("rel", "alternate");
    link.setAttribute("hreflang", hreflang);
    link.setAttribute("href", href);
    this.document.head.appendChild(link);
  }

  private removeLinks(selector: string) {
    const nodes = this.document.head.querySelectorAll(selector);
    nodes.forEach((n) => n.parentNode?.removeChild(n));
  }
}
